import * as actionType from "../Actions/Action_Type";
import * as ROLES from "../Utils/Roles_Types.js";
import {LABEL_InvalidPassword} from "../Utils/Strings/Labels";
import { checkUserLanguage } from "../Utils/Check_Value";

import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROUTE       from "../Utils/Strings/Route";
const USERLANGUAGE  = checkUserLanguage();

const initialState = {
  isFetching                 : false,
  errorMessage               : null,
  isAuthenticated            : false,
  changePasswordDialogOpened : false,
  errorOldPassword           : null,
  errorNewPassword           : null,
  languageList               : null
};

const impostazioneReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SERVICE_CHANGEPASSWORD_OPENDIALOG : 
            return Object.assign({}, state, {
                changePasswordDialogOpened : true
            })
    case actionType.SERVICE_CHANGEPASSWORD_CLOSEDIALOG : 
            return Object.assign({}, state, {
                changePasswordDialogOpened : false
            })
    //CAMBIO PASSWORD
    case actionType.SERVICE_CHANGEPASSWORD_REQUEST :
            return Object.assign({}, state, {
                changePasswordError : null, 
                isFetching: true
            })
    case actionType.SERVICE_CHANGEPASSWORD_SUCCESS :
        return Object.assign({}, state, {
            isFetching    : false,
            changePasswordError : null, 
            changePasswordDialogOpened : false,
            isAuthenticated : true
        })
    case actionType.SERVICE_CHANGEPASSWORD_ERROR :
        var OldPassword = null, NewPassword = null;
    
        if(action.error === 'Password non corretta.')
            OldPassword = LABEL_InvalidPassword[USERLANGUAGE];
        else
            OldPassword = LABEL_InvalidPassword[USERLANGUAGE];
        
        return Object.assign({}, state, {
            isFetching : false,
            errorOldPassword : OldPassword,
            errorNewPassword : NewPassword
        })
    //Cambio Lingua
    case actionType.SERVICE_LANGUAGE_GET_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
    case actionType.SERVICE_LANGUAGE_GET_SUCCESS :
        return Object.assign({}, state, {
            isFetching    : false,
            changePasswordDialogOpened : true,
            languageList  : action.response,
            isAuthenticated : true
        })
    case actionType.SERVICE_LANGUAGE_GET_ERROR :
        return Object.assign({}, state, {
            isFetching : false,
        })
    //SETTA LINGUA
    case actionType.SERVICE_LANGUAGE_SET_REQUEST :
            return Object.assign({}, state, {
                isFetching: true
            })
    case actionType.SERVICE_LANGUAGE_SET_SUCCESS :
        const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
        USERINFO.Language = action.response;
        localStorage.setItem(ROLES.USERINFO_KEY, JSON.stringify(USERINFO));
        setTimeout(() => {
            PAGESSWITCH.gotoPageWithParams(ROUTE.Home);
            setTimeout( () => window.location.reload(), 10 );
        }, 200);
        return Object.assign({}, state, {
            isFetching    : false,
            changePasswordDialogOpened : false,
            isAuthenticated : true
        })
    case actionType.SERVICE_LANGUAGE_SET_ERROR :
        return Object.assign({}, state, {
            isFetching : false,
        })
    default:
      return state;
  }
};

export default impostazioneReducer;


// WEBPACK FOOTER //
// ./src/Reducers/Reducer_Impostazioni.js